import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import { ToursStateService } from 'src/app/services/tours-state.service';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";
import {SearchService} from "../../../services/search/search.service";

@Component({
  selector: 'app-incorrect-filters',
  templateUrl: './incorrect-filters.component.html',
  styleUrls: ['./incorrect-filters.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class IncorrectFiltersComponent {
  messages: any = {
    titleText: 'Ничего не найдено',
    hintText: 'Попробуйте изменить параметры поиска или сбросить фильтры.',
    resetFiltersText: 'Сбросить фильтры',
  };

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private state: ToursStateService,
    private searchService: SearchService
  ) {
    this.messages = {
      ...this.messages,
      ...this.hotelToursPageConfig.translates.incorrectFilters,
      resetFiltersText: 'Сбросить фильтры',
    };
  }

  resetFilters() {
    this.state.resetFilters();
    this.searchService.filtersReset();
  }
}
